export default __webpack_public_path__ + "static/benefits-cost-7df6f5fff3ea02016a56f7b647395c6e.mp4";